import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		paddingInline: token('space.300'),
		height: '100%',
	},
	container: {
		width: '100%',
		maxWidth: '600px',
		textAlign: 'center',
	},
	textBlock: {
		paddingBlockStart: token('space.200'),
	},
	heading: { font: token('font.heading.medium') },
});

export type BaseEmptyStateProps = {
	illustration: React.ReactNode;
	heading: React.ReactNode;
	description: React.ReactNode;
	cta?: React.ReactNode;
	singleColumn?: boolean;
};

export const BaseEmptyState = ({
	illustration,
	heading,
	description,
	cta,
	singleColumn,
}: BaseEmptyStateProps): React.JSX.Element => (
	<Box xcss={styles.wrapper}>
		<Stack xcss={styles.container}>
			{illustration}
			<Stack space="space.500" xcss={styles.textBlock}>
				<Stack space="space.250">
					<Box as={singleColumn ? 'h3' : 'h2'} xcss={styles.heading}>
						{heading}
					</Box>
					<Text as="p">{description}</Text>
				</Stack>
				{cta && (
					<Inline alignInline="center" space="space.150">
						{cta}
					</Inline>
				)}
			</Stack>
		</Stack>
	</Box>
);

export const illustrationStyle: React.CSSProperties = {
	maxWidth: '100%',
	height: 'auto',
	marginInline: 'auto',
};
